export const interceptorPageStatusCodes = [403, 404, 400, 410, 500];
